import CalendarDataSchema from '@lts-web/schemas/CalendarDataSchema';
import { readOnlyProperty } from '@lts-web/utils/ObjectUtil';
import CalendarLinkData from "@lts-web/data-objects/CalendarLinkData";

class CalendarData {
    constructor (data) {
        this._data = CalendarDataSchema(data);

        readOnlyProperty(this, '_data');
        readOnlyProperty(this._data, 'date');
        readOnlyProperty(this._data, 'availability');
    }

    getDate () {
        return this._data.date;
    }

    getFormat () {
        return this._data.dateFormat;
    }

    getLinks () {
        return this._data.links;
    }

    getAvailability () {
        return this._data.availability;
    }

    addLink (date, priority, availability) {
        const links = this._data.links;

        if (!links.hasOwnProperty(date))
            return (links[date] = new CalendarLinkData({ date, priority, availability }));

        return false;
    }

    getLink (date) {
        return this.isLinkAvailable(date) ? this._data.links[date] : null;
    }

    isLinkAvailable (date) {
        return this._data.links.hasOwnProperty(date);
    }
}

export default CalendarData;